import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

const action = '刷新制品标题'

export default () => {
    const map = useMapContext()

    const onClick = async () => {
        const {bizNodeType, pkid, prjId, sVer} = map.root.data

        await runAsync(
            () => http.post('/dps/refresh', {bizNodeType, pkid, prjId, sVer}),
            {action}
        )
    }

    return {
        key: 'sync-design-title',
        label: action,
        onClick,
    }
}
